module.exports = __webpack_public_path__ + "static/media/up-arrow-svgrepo-com (5).d59fc8ac.svg";